import axios from '@/http.js';
import qs from 'qs';
export const MATERIAL_QUERY_API = 'api/tplEditMaterials';
export const YANXUAN_QUERY_API = 'api/material/yxItemDetailPics';
export default {
  getMaterialList (params) {
    const url = `api/materials`;
    return axios.post(url, params);
  },
  getMaterialListByUrl (url, params) {
      return axios.post(url, params);
  },
  getMaterialListForEditor (params) {
    const url = `api/tplEditMaterials`;
    return axios.post(url, params);
  },
  getBgColorListForEditor (projectId, type, tplGroupIds) {
    let url = '/api/theme/color/tplEditQuery';
    return axios.post(url, {projectId, type, tplGroupIds});
  },
  saveMaterial (param) {
    return axios.post('api/material/save', param);
  },
  updateMaterial (param) {
    return axios.put('api/material/edit', param);
  },
  deleteMaterials (param) {
    return axios.delete('/api/material', {
      params: {
        ids: param,
      },
      paramsSerializer: params => {
        return qs.stringify(params, {indices: false});
      }
    });
  },
  getMaterialsByGroupId (groupId) {
    let url = `api/materialGroup/${groupId}`;
    return axios.get(url);
  },
  getMaterialsSize (params) {
    return axios.get(`api/material/list/widght`, {params: {type: params.type}, headers: {projectId: params.projectId}});
  },
  batchSaveBGMaterial (param) {
    return axios.post('/api/material/batchSaveBg', param);
  },
  batchSaveMaterial (param) {
    return axios.post('/api/material/batchSave', param);
  },
  downloadUselessMaterial (param) {
    // return axios.get(`/api/storage/download/zip`, {params: {storageIds: array}});
    return axios({
      method: 'get',
      url: '/api/storage/download/zip',
      params: {
        storageIds: param,
      },
      paramsSerializer: params => {
        return qs.stringify(params, {indices: false});
      },
      responseType: 'blob',
    })
  },
  getBgColorList (projectId, type, tplGroupIds) {
    let url = '/api/theme/color/query';
    return axios.post(url, {projectId, type, tplGroupIds});
  },
  getGroupList (projectId) {
    let url = `/api/material/group/list`;
    return axios.get(url, {headers: {projectId}});
  },
  setGroup (projectId, params) {
    let url = `api/bgMaterial/setGroup`;
    return axios.put(url, params, {headers: {projectId}});
  },
  saveGroup (params) {
    let url = `api/material/group/save`;
    return axios.post(url, params);
  },
  editThemeColor (params) {
    let url = `api/material/group`;
    return axios.put(url, params);
  },
  saveBgColor (params) {
    let url = `api/theme/color/save`;
    return axios.post(url, params);
  },
  editBgColor (params) {
    let url = `api/theme/color/edit`;
    return axios.put(url, params);
  },
  deleteBgColor (ids) {
    return axios.delete('/api/theme/color/delete', {
      params: {
        ids: ids,
      },
      paramsSerializer: params => {
        return qs.stringify(params, {indices: false});
      }
    });
  },
  getMaterialTag (projectId) {
    let url = `api/tag`;
    return axios.get(url, {params: {type: 'MATERIAL'}, headers: {projectId}});
  },
  setMaterialTag (params, projectId) {
    let url = `api/tag/set/material`;
    return axios.put(url, params, {headers: {projectId}});
  },
  batchSetMaterialTag (params, projectId) {
    let url = 'api/tag/batchSet/material';
    return axios.put(url, params, {headers: {projectId}});
  },
  saveMaterialForPSCache (projectId, type, data) {
    let url = '/api/cutout/step';
    return axios.post(url, {json: data ? JSON.stringify(data) : ''}, {headers: {type: type, projectId: projectId}});
  },
  getPSCache (userId) {
    let url = `/api/cutout/step/${userId}`;
    return axios.get(url);
  },
  addThemeForBgImg (bgId, themeId) {
    let url = 'api/material/bgBindTheme';
    return axios.put(url, {bgId, themeId});
  },
  addMaterialGroup (projectId, materialIds, tplGroupId) {
    let url = 'api/material/addToTplGroup';
    return axios.put(url, {materialIds, tplGroupId}, {
      headers: {projectId}
    });
  },
  updateMaterialGroup (projectId, materialId, tplGroupIds) {
    let url = 'api/material/updateTplGroup';
    return axios.put(url, {materialId, tplGroupIds}, {
      headers: {projectId}
    });
  },
  addBgColorGroup (projectId, themeIds, tplGroupId) {
    let url = 'api/theme/color/addToTplGroup';
    return axios.put(url, {themeIds, tplGroupId}, {
      headers: {projectId}
    });
  },
  updateBgColorGroup (projectId, themeId, tplGroupIds) {
    let url = 'api/theme/color/updateTplGroup';
    return axios.put(url, {themeId, tplGroupIds}, {
      headers: {projectId}
    });
  },
  delBgGroup (id, projectId) {
    let url = `api/material/group/${id}`;
    return axios.delete(url, {headers: {projectId}});
  },
  unlinkBgGroup (id, projectId) {
    let url = `api/material/unlinkBg/${id}`;
    return axios.put(url, null, {headers: {projectId}});
  },
  removeMaterialGroup (projectId, id) {
    let url = `api/material/cancelTplGroup/${id}`;
    return axios.delete(url, {headers: {projectId}});
  },
  getYanXuanMaterialById (projectId, itemId) {
    const url = `api/material/yxItemDetailPics?itemId=${itemId}`;
    return axios.get(url, {
      headers: {projectId}
    });
  },
}